import React from 'react';
import { GREY_Q } from '../../../constants/Colors';
import { createStyles } from '../../../utils/css';
import Spinner from '../../svgs/Spinner';

interface IProps {
  color?: '#888';
}

/**
 * Spinner that attempts to fill the height of its content. Good for search boxes and pages that load
 * the main content.
 *
 * All components that contain this must have cascading heights stretch to 100%.
 */
const ContentSpinner = ({ color = GREY_Q }: IProps) => (
  <Styles>{(css) => (
    <div className={css('container')}>
      <div data-testid="content-spinner" className={css('spinner')}>
        <Spinner color={color} />
      </div>
    </div>
  )}</Styles>
);

const Styles = createStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
    margin: '0',
    padding: '3em',
  },
  spinner: {
    minWidth: '100px',
    maxWidth: '150px',
    width: '30%',
  },
});

export default ContentSpinner;
